import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import ScrollReveal from "scrollreveal";
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"
//import Masonry from "masonry-layout/dist/masonry.pkgd.min.js"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();


    function slider() {

      $(".c-mainvisual-slider .owl-carousel").owlCarousel({
        items: 1,
        dots: true,
        loop: true,
        nav: false,
        autoplay: true,
        autoplaySpeed: 5600,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        autoWidth: false,
        autoHeight: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false
      });

      $(".c-section-media__slider.owl-carousel").owlCarousel({
        //responsiveClass:true,
        dots: false,
        loop: false,
        autoplay: true,
        autoplaySpeed : 1800,
        autoWidth: false,
        autoHeight: false,
        center: true,
        navText: ['<img src="/wp-content/themes/lantelno-html/dist/assets/images/img-slider-prev.png" />','<img src="/wp-content/themes/lantelno-html/dist/assets/images/img-slider-next.png" />'],
        responsive : {
          0 : {
            items: 3,
            nav: true,
          },
          750 : {
            items: 5,
            nav: true,
          },
          950 : {
            items: 5,
            nav: true,
            center: false,
          },
          1400 : {
            items: 5,
            nav: true,
            center: false,
          }
        }
      });



      function setNavigationButtons(event) {
        $(".c-course-slider__thumbnail-item").removeClass("is-active");
        $(".c-course-slider__thumbnail-item:nth-child(" + (event.page.index + 1) + ")").addClass("is-active")

      }

      function initialize(event) {
        $(".c-course-slider__thumbnail-item:nth-child(1)").addClass("is-active");
      }


      var owl = $(".c-course-slider__slider").owlCarousel({
        items: 1,
        dots: true,
        loop: true,
        nav: true,
        navText: ["<img src='/wp-content/themes/lantelno-html/dist/assets/images/img-slide-arrow-left.png' alt=''>", "<img src='/wp-content/themes/lantelno-html/dist/assets/images/img-slide-arrow-right.png' alt=''>"],
        autoplay: true,
        autoplaySpeed: 5000,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        autoWidth: false,
        autoHeight: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        URLhashListener: true,
        onTranslate: setNavigationButtons,
        onInitialized: initialize,
      });

    }

    function scrollReveal() {

      // スクロールリーバル
      window.sr = new ScrollReveal({duration: 1200, mobile: true});

      // scroll add class
      // https://github.com/scrollreveal/scrollreveal/issues/337#issuecomment-309657013
      sr.watch = function (target, onEnter, onExit) {
        onExit = onExit || function () {
        }
        if (typeof onEnter === 'function' && typeof onExit === 'function') {
          var noEffect = {
            delay: 0,
            distance: 0,
            duration: 0,
            scale: 1,
            opacity: null,
            rotate: {x: 0, y: 0, z: 0,},

            reset: true,
            beforeReset: onExit,
            beforeReveal: onEnter,
          }
          this.reveal(target, noEffect)
        } else {
          throw new Error('Watch received invalid arguments.')
        }
      };
      sr.watch('.js-reveal-blur,.js-reveal-blur-medium,.js-reveal-blur-long',
        function onEnter(el) {
          el.classList.add('js-reveal-blur-active')
        },
        function onExit(el) {
          // el.classList.remove('js-reveal-blur-active')
        }
      )

      sr.reveal(".js-reveal-fade,.instagram .c-instagram__item", {scale: 1, duration: 1200, distance: '0', delay: 0}, 100);
      sr.reveal(".js-reveal-fade-medium", {scale: 1, duration: 1200, distance: '0', delay: 300}, 100);
      sr.reveal(".js-reveal-fade-long", {scale: 1, duration: 1200, distance: '0', delay: 600}, 100);
      sr.reveal(".js-reveal-slidedown", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'top',
        delay: 300
      }, 100);
      sr.reveal(".js-reveal-slidedown-short", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'top',
        delay: 0
      }, 100);
      sr.reveal(".js-reveal-slidedown-medium", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'top',
        delay: 300
      }, 100);
      sr.reveal(".js-reveal-slidedown-long", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'top',
        delay: 600
      }, 100);
      sr.reveal(".js-reveal-slideup-short", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'bottom',
        delay: 0
      }, 100);
      sr.reveal(".js-reveal-slideup-medium", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'bottom',
        delay: 300
      }, 100);
      sr.reveal(".js-reveal-slideup-long", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'bottom',
        delay: 600
      }, 100);
      sr.reveal(".js-reveal-slideleft", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'right',
        delay: 600
      }, 100);

      sr.reveal(".js-reveal-slideright", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'left',
        delay: 600
      }, 100);


      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }

        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }
      var blocks01 = $(".js-reveal-chain");
      domEach(blocks01, function (key, item) {
        sr.reveal(item, {scale: 1, delay: 500, duration: 400, distance: '10px'}, 100);
        sr.reveal(item.children[1], {delay: 500, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[2], {delay: 600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[3], {delay: 700, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[4], {delay: 800, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 10);
        sr.reveal(item.children[5], {delay: 900, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[6], {delay: 1000, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[7], {delay: 1100, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[8], {delay: 1200, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[9], {delay: 1300, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[10], {delay: 1400, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 10);
        sr.reveal(item.children[11], {delay: 1500, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[12], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[13], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[14], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[15], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[16], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[17], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[18], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[19], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[20], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[21], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[22], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[23], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[24], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[25], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[26], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[27], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
      });


    }

    function scrollAdaptive() {

      $(window).on('scroll', function (event) {
        // ヘッダーの高さを取得
        var header_height = $(".l-header").height() + 100;
        // elScrollableは別項「スクロール位置の取得」を参照
        var scroll_top = $(window).scrollTop();

        if (scroll_top >= header_height) {
          $("body").addClass("is-scrolling");
        } else {
          $("body").removeClass("is-scrolling");
        }
      });
    }

    function button_decoration() {
      $(".c-button").append('<span class="line-1"></span><span class="line-2"></span><span class="line-3"></span><span class="line-4"></span>');


    }

    // function masonry() {
    //   var masonry = new Masonry( '.c-instagram', {
    //     itemSelector: '.c-instagram__item',
    //     columnWidth: 80,
    //     gutter: 7
    //   });
    //
    // }

    $(function () {
      slider();
      scrollReveal();
      scrollAdaptive();
      button_decoration();
      //masonry();


    });
  }
}

window.GApp = new App();
